<onsip-signup-common-layout>
  <div class="left-content">
    <div class="onsip-signup-title create-profile">
      {{ "ONSIP_I18N.CREATE_YOUR_PROFILE" | translate }}
    </div>
    <div class="avatar-container">
      <onsip-avatar
        [avatarUrl]="!tempAvatar || tempAvatar === '' ? avatarPlaceholder : tempAvatar"
      ></onsip-avatar>
      <button mat-button color="primary" class="avatar-upload-button" (click)="uploadAvatar()">
        {{ "ONSIP_I18N.UPLOAD_PROFILE_PHOTO" | translate }}
      </button>
    </div>
    <form [formGroup]="profileInfo" class="profile-form" (ngSubmit)="next()">
      <mat-form-field appearance="outline" class="onsip-outlined-form">
        <mat-label>{{ "ONSIP_I18N.FULL_NAME" | translate | titlecase }}</mat-label>
        <input matInput formControlName="fullname" />
        <mat-error>{{ getNameErrors("fullname") }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="onsip-outlined-form">
        <mat-label>{{ "ONSIP_I18N.USERNAME" | translate }}</mat-label>
        <input matInput formControlName="username" autocomplete="off" />
        <mat-error>{{ getNameErrors("username") }}</mat-error>
      </mat-form-field>
      @if (!entryService.isOauth) {
        <mat-form-field appearance="outline" class="onsip-outlined-form">
          <mat-label>{{ "ONSIP_I18N.PASSWORD" | translate }}</mat-label>
          <input matInput formControlName="pword" type="password" />
          <mat-hint>{{
            "ONSIP_I18N.MINIMUM_12_CHARACTERS_WITH_AT_LEAST_1_SYMBOL_AND_1_NUMBER" | translate
          }}</mat-hint>
          <mat-error>{{ getPasswordErrors("pword") }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="onsip-outlined-form">
          <mat-label>{{ "ONSIP_I18N.CONFIRM_PASSWORD" | translate }}</mat-label>
          <input matInput formControlName="verify" type="password" />
          <mat-error>{{ getPasswordErrors("verify") }}</mat-error>
          <mat-hint>{{
            "ONSIP_I18N.MINIMUM_12_CHARACTERS_WITH_AT_LEAST_1_SYMBOL_AND_1_NUMBER" | translate
          }}</mat-hint>
        </mat-form-field>
      }
      @if (isBeta) {
        <mat-form-field appearance="outline" class="onsip-outlined-form">
          <mat-label>Contact organization</mat-label>
          <input matInput type="text" formControlName="orgName" autocomplete="off" />
          <mat-error>{{ getOrgErrors() }}</mat-error>
        </mat-form-field>
      }
      <mat-form-field appearance="outline" class="onsip-outlined-form">
        <mat-label>{{ "ONSIP_I18N.JOB_TITLE" | translate }}</mat-label>
        <input matInput type="text" formControlName="title" autocomplete="off" />
        <mat-error>{{ getTitleErrors() }}</mat-error>
      </mat-form-field>
      <div class="signup-button-container">
        <button mat-flat-button type="submit" color="primary">
          {{ getSubmitText() }}
        </button>
      </div>
    </form>
  </div>
</onsip-signup-common-layout>
